var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          attrs: { accordion: "" },
          model: {
            value: _vm.activeNames,
            callback: function($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames"
          }
        },
        [
          _c(
            "el-collapse-item",
            {
              attrs: { title: "1.Who can be a ShopVidi customer?", name: "1" }
            },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v("\n            a) Brick & mortar store "),
                _c("br"),
                _vm._v("\n            b) Online boutique "),
                _c("br"),
                _vm._v("\n            c) Shop in shops/Pop-up store\n      ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            {
              staticClass: "item-low",
              attrs: {
                title:
                  "2.How long does it take to receive the goods after placing an order?",
                name: "2"
              }
            },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v(
                  "\n               a) Shipping from local warehouse: 3-5 days (USA）"
                ),
                _c("br"),
                _vm._v(
                  "\n                b) Shipping from cross-border warehouse: 10-15 days (China）\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: "3.Limitations of order-placing policy?",
                name: "3"
              }
            },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v("\n                  a) No MOQ limitation "),
                _c("br"),
                _vm._v("\n                  b) No brand limitation "),
                _c("br"),
                _vm._v(
                  "\n                  c) Free shipping on opening order\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            { attrs: { title: "4.How to finish the payment?", name: "4" } },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v("\n        a) By credit card (Visa/MasterCard）"),
                _c("br"),
                _vm._v(
                  "\n        b) By approved net term credit  (Only for brick & mortar stores）"
                ),
                _c("br"),
                _vm._v(
                  "\n          Currently, we only  offer brick-and-mortar store owners in the US the option to apply for a net 60 terms."
                ),
                _c("br"),
                _vm._v(
                  "\n          You need to submit the following information to the financial institution:"
                ),
                _c("br"),
                _vm._v("\n            I. The repayment card"),
                _c("br"),
                _vm._v(
                  "\n           II. Store information, such as store photo, invoice and transaction records for the past 3 months, business registration information\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: "5.How does ShopVidi guarantee prices? ",
                name: "5"
              }
            },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v(
                  "\n           a) All brands come directly from the manufacturer to ensure the best price for you "
                ),
                _c("br"),
                _vm._v(
                  "\n          b) If you do happen to find better pricing online for any of the products on ShopVidi, we'll match their offer. "
                ),
                _c("br"),
                _vm._v(
                  "\n          c) Only verified wholesale clients can see the wholesale price\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: "6.  How does ShopVidi’s quality control work? ",
                name: "6"
              }
            },
            [
              _c("div", { staticClass: "collapse-content" }, [
                _vm._v(
                  "\n            a) The samples by each brand will be reviewed carefully while on the shelf "
                ),
                _c("br"),
                _vm._v(
                  "\n            b) Every order will be delivered only after QA processing at our warehouse "
                ),
                _c("br"),
                _vm._v(
                  "\n            c) Every complaint related to quality will be highly valued by ShopVidi and refunded by the recognized order to the purchaser\n      "
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2ced24c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ced24c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/collapse.vue
// module id = null
// module chunks = 